import React from 'react'

import { tagLinkBlocksShape } from 'Pods/Shared/TagLinkRow/tagLinkBlocksShape'
import TagLinkRow from 'Pods/Shared/TagLinkRow/TagLinkRow'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

function TagLinkRelated({ blocks = null }) {
  if (!blocks) {
    return null
  }

  const relatedTags = blocks.relatedTags || EMPTY_ARRAY
  const categoryHubs = blocks.categoryHubs || EMPTY_ARRAY

  if (relatedTags.length === 0 && categoryHubs.length === 0) {
    return null
  }

  return (
    <div className="tag-link-related">
      <TagLinkRow label={blocks.relatedHeading} links={relatedTags} />
      <TagLinkRow label={blocks.hubsHeading} links={categoryHubs} />
    </div>
  )
}

TagLinkRelated.propTypes = {
  blocks: tagLinkBlocksShape,
}

export default TagLinkRelated
